import CategoryLeaders from './CategoryLeaders'

export default CategoryLeaders
